import PropTypes from "prop-types";
import { Button } from "antd";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { ACTION_SIZE_LG, SECONDARY_ACTION, getCustomerName } from "../utils";

const CustomerProfileCard = ({ resDetails, customerDetails, t }) => {
    const customerName = getCustomerName(resDetails, customerDetails);
    const phone = customerDetails?.mobileNumber
        ? parsePhoneNumberFromString(`+${customerDetails.mobileNumber}`)?.formatNational()
        : null;
    const email = customerDetails?.email || resDetails?.email;
    const memberSince = customerDetails?.createdAt
        ? new Date(customerDetails.createdAt).getFullYear()
        : null;
    const tripCount = customerDetails?.totalTrips ?? customerDetails?.tripCount ?? null;

    return (
        <div className="rounded-2xl border border-[#f0f0f0] bg-white p-4 lg:p-5">
            <div className="flex flex-col items-center text-center">
                {customerDetails?.userImage ? (
                    <img
                        src={customerDetails.userImage}
                        alt={customerName}
                        className="h-20 w-20 rounded-full object-cover"
                    />
                ) : (
                    <div className="flex h-20 w-20 items-center justify-center rounded-full bg-[#666] text-white">
                        {customerName.charAt(0)?.toUpperCase() || "?"}
                    </div>
                )}

                <h2 className="fontSemi mt-4 text-lg text-[#2F2F46]">{customerName}</h2>
                <p className="fontRegular mt-1 text-sm text-[#7f8c8d]">
                    {memberSince
                        ? t("upcomingDetails.customerSinceTrips", {
                              year: memberSince,
                              trips: tripCount ?? 0,
                          })
                        : t("resDetails.viewProfile")}
                </p>
            </div>

            <div className="mt-5 space-y-3">
                {phone ? (
                    <div className="flex items-center gap-3 text-sm text-[#2F2F46]">
                        <PhoneOutlined className="text-[#5D5DF6]" />
                        <span>{phone}</span>
                    </div>
                ) : null}
                {email ? (
                    <div className="flex items-center gap-3 text-sm text-[#2F2F46]">
                        <MailOutlined className="text-[#5D5DF6]" />
                        <span className="break-all">{email}</span>
                    </div>
                ) : null}
            </div>

            <Link to={resDetails?.userUID ? `/customers/${resDetails.userUID}` : "#"} className="mt-5 block">
                <Button block className={`${ACTION_SIZE_LG} ${SECONDARY_ACTION}`}>
                    {t("upcomingDetails.viewFullProfile")}
                </Button>
            </Link>
        </div>
    );
};

CustomerProfileCard.propTypes = {
    resDetails: PropTypes.object,
    customerDetails: PropTypes.object,
    t: PropTypes.func.isRequired,
};

export default CustomerProfileCard;
